module.exports = __webpack_public_path__ + "static/media/HW-purplish-blue.3bfc89f0.svg";